import set from 'lodash/set';
import React from 'react';
import ReactDOM from 'react-dom';
import 'src/shared/a11y/reactAxe';
import {Provider} from 'react-redux';
import {App} from 'src/pages/scheduleCallback/components/App';
import {store} from 'src/pages/scheduleCallback/store';
import {startFlow} from 'src/pages/scheduleCallback/store/actions/startFlow';
import 'src/styles/base.scss';

store.dispatch(startFlow());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);

set(window, 'XHS.store', store);
